"use strict";
var _ItemUpdate_model;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ImageProvider_1 = tslib_1.__importDefault(require("../../../../../services/ImageProvider"));
const defaultValue = {
    data: {
        type: 'item',
        attributes: {},
    },
};
class ItemUpdate {
    constructor(attributes) {
        _ItemUpdate_model.set(this, defaultValue);
        tslib_1.__classPrivateFieldGet(this, _ItemUpdate_model, "f").data.attributes = attributes;
    }
    async processImages() {
        const { photos_attributes } = tslib_1.__classPrivateFieldGet(this, _ItemUpdate_model, "f").data.attributes;
        const Promises = (photos_attributes || []).map(async (data) => {
            var _a;
            const isBase64 = data.photo && data.photo.startsWith('data:image');
            const isAlreadyUploaded = data.photo && data.photo.includes('cdn-cgi');
            const shouldRemoveFromList = isAlreadyUploaded && data.id;
            if (shouldRemoveFromList) {
                data.photo_image_id = (((_a = data.photo) === null || _a === void 0 ? void 0 : _a.split('/')) || []).at(-2);
                delete data.photo;
                return data;
            }
            if (isBase64) {
                const imageProvider = new ImageProvider_1.default(data.photo);
                await imageProvider.upload();
                data.photo_image_id = imageProvider.image_id;
                delete data.photo;
            }
            return data;
        });
        const data = await Promise.all(Promises);
        tslib_1.__classPrivateFieldGet(this, _ItemUpdate_model, "f").data.attributes.photos_attributes = data;
    }
    get data() {
        return tslib_1.__classPrivateFieldGet(this, _ItemUpdate_model, "f");
    }
}
exports.default = ItemUpdate;
_ItemUpdate_model = new WeakMap();
//# sourceMappingURL=Item.js.map